import React, {Component} from 'react';
import {Redirect} from "react-router-dom";
import PaymentSuccessImage from '../../../../../assets/img/paymentSuccessImg.png';
import PriceLoadingImage from "../../../../../assets/img/loading_price.gif";
import OrderFailImage from "../../../../../assets/img/orderFailImage.png";
import OrderCancelledImage from "../../../../../assets/img/cancelledImg.png";
import axios from "axios";
import {BASE_URL, LIVE_MODE, RESOURCE_BASE_URL} from "../../../../../configuration";

class StripeSuccessComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            stripeOrderInProgress : false,
            transactionSuccess : false,
            btnActivated : false,
            stripeOrderPlacingError : false
        };

        this.placeStripeOrder = this.placeStripeOrder.bind(this);
        this.redirectToHome = this.redirectToHome.bind(this);
        this.redirectToMyPage = this.redirectToMyPage.bind(this);

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.userData !== this.props.userData) {
            this.setState({userId: this.props.userId});
            localStorage.removeItem("roc");

            let cartDetails = JSON.parse(localStorage.getItem("stp"));

            if(cartDetails !== null){

                if(cartDetails !== 1){
                    localStorage.setItem("stp", "1");
                    this.setState({
                        stripeOrderInProgress : true
                    }, ()=>this.placeStripeOrder(cartDetails));
                }else if(cartDetails === 1){
                    this.setState({
                        stripeOrderInProgress : true
                    });

                    setTimeout(()=>{
                        this.setState({
                            stripeOrderInProgress : false,
                            transactionSuccess : true
                        });

                    }, 5000);
                }

            }else {
                //activate paypal success messages
                this.setState({
                    transactionSuccess : true
                }, ()=> {console.log("transaction success")})

            }
        }

    }

    componentDidMount() {
        window.scrollTo(0,0);

    }

    componentWillUnmount() {

        localStorage.removeItem("stp");
        localStorage.removeItem("ppe");
    }


    redirectToHome = () => {
        this.setState({
            redirect : true,
            stripeOrderInProgress : false,
        })
    };

    placeStripeOrder = (cartInfo) => {
           // console.log("Place stripe order ====> ", cartInfo);
           if (this.props.userId !== "") {
               let axiosConfig = {
                   headers: {
                       'Content-Type': 'application/json;charset=UTF-8',
                       "Access-Control-Allow-Origin": "*",
                   }
               };
               let orderData = {
                   userId: cartInfo.userId,
                   cartItemIds: cartInfo.cartItemIds,
                   paymentId: cartInfo.paymentId,
                   total: cartInfo.total,
                   discount:cartInfo.discount,
                   paymentMethod : cartInfo.paymentMethod
               };

               // console.log("ORDER PLACING REQUEST DUO ====================> ", cartInfo);

               axios.post(RESOURCE_BASE_URL + 'api/users/' + cartInfo.userId + '/orders', orderData, axiosConfig)
                   .then((res) => {
                       // console.log("ORDER PLACED SUCCESSFULLY DUO ====================> ", res.data);
                       this.props.getCartItems();
                       this.setState({
                           stripeOrderInProgress : false,
                           transactionSuccess : true

                       });
                   })
                   .catch((err) => {
                       console.log("[API] ERROR: ", err);
                       this.setState({
                           stripeOrderPlacingError : true,
                           stripeOrderInProgress : false,
                           btnActivated : true
                       });
                   });

           } else {
           }

    };
    redirectToMyPage = () => {
        //window.open(BASE_URL + 'order/all', '_self')
        this.setState({
            redirect : true,
            stripeOrderInProgress : false,
        })
    };

    render() {
        const {redirect} = this.state;

        if (redirect) {
            //return <Redirect to='/'/>;
            return <Redirect to='/order/all'/>;
        }
        return (
            <div className="text-center success-ui-message-div">

                <div hidden={!this.state.transactionSuccess}>
                <img src={PaymentSuccessImage} alt="支払いが成功しました!" className="payment-success-resp-img"/>
                <h3 className="success-text-resp">支払い済み</h3><br/>
                <p className="success-text-content">ありがとうございます。</p>
                <p className="success-text-content">注文が確定されました。</p>
                <div><button onClick={this.redirectToMyPage} className="btn btn-success btn-color-payment-mobile">マイページへ</button></div>
                {/*<div><button onClick={this.redirectToHome} className="btn btn-info btn-color-payment-mobile">ホームページへ</button></div>*/}
                </div>

                <div hidden={this.state.transactionSuccess}>
                    <h4 hidden={!this.state.stripeOrderInProgress} className="success-text-content-processing">ご注文を受け付けています。<br/><br/>お待ちください...</h4>
                    <img hidden={!this.state.stripeOrderPlacingError} src={OrderCancelledImage} alt="キャンセルされました" className="payment-failcomp-resp-img"/>
                    <h4 hidden={!this.state.stripeOrderPlacingError} className="text-danger payment-error-resp">注文に失敗しました。お支払いは正常に返金されました。</h4>
                    <img hidden={!this.state.stripeOrderInProgress} src={PriceLoadingImage} className="order-placing-progress" alt="Loading..."/><br/>
                    <div hidden={!this.state.btnActivated}><button onClick={this.redirectToMyPage} className="btn btn-success btn-color-payment-mobile">マイページへ</button></div>
                </div>

            </div>
        );
    }
}

export default StripeSuccessComponent;



// WEBPACK FOOTER //
// ./src/components/Site/Order/OrderConfirmationBottom/StripeComponents/StripeSuccessComponent.js